import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getAllDotypeAction = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCTYE_ACTIONS + `/getAll`);
};
export const getbyobjectgroup_id = (objectgroup_id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCTYE_ACTIONS + `/getbyobjectgroup_id/${objectgroup_id}`);
};